import { Component, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, InteractionStatus } from '@azure/msal-browser';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { filter, Subject, takeUntil } from 'rxjs';
import { HomeService } from './services/home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  user!: AccountInfo;
  region = localStorage.getItem('region') || 'unknown';
  registered: any[] = [];
  deleted: any[] = [];
  usersStats: any;
  totalNumberOfUsers: number = 0;
  isLoadingStats: boolean = false;
  isLoadingStatsErrorOccured: boolean = false;
  view: [number, number] = [635, 400];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;

  colorScheme: Color = {
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
      'var(--primaryBg)',
      'var(--secondChartColor)',
      'var(--thirdChartColor)',
      'var(--fourthChartColor)',
    ],
  };

  loginDisplay: boolean = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private homeService: HomeService
  ) {}

  ngOnInit(): void {
    this.setDefaultRegion();
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        if (this.loginDisplay) {
          this.getActiveAndInactiveUsers();
        }
      });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    this.user = this.authService.instance.getAllAccounts()[0];
    if (this.user != undefined) {
      localStorage.setItem('user', JSON.stringify(this.user));
      localStorage.setItem('username', this.user?.username);
    }
  }

  setDefaultRegion() {
    if (localStorage.getItem('region') == null) {
      localStorage.setItem('region', 'North America');
      window.location.reload();
    } else if (localStorage.getItem('region') == 'Global') {
      localStorage.setItem('region', 'North America');
      window.location.reload();
    }
  }

  getActiveAndInactiveUsers() {
    this.isLoadingStats = true;
    this.homeService.getActiveAndInactiveUsers().subscribe(
      (data) => {
        this.usersStats = data;
        this.totalNumberOfUsers =
          this.usersStats.activeUsers + this.usersStats.inactiveUsers;
        this.registered = this.usersStats.hpgraph;
        this.deleted = this.usersStats.hpgraphDeleted;
        this.isLoadingStats = false;
      },
      (error) => {
        this.isLoadingStats = false;
        this.isLoadingStatsErrorOccured = true;
      }
    );
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
